import React from 'react';
import { Box, Flex, Text, useColorMode } from 'theme-ui';
import { LuRotateCcw } from 'react-icons/lu';
import { CircleCounterProps } from './types';

const CircleCounter: React.FC<CircleCounterProps> = ({ label, value, total, onChange, onCircleClick, labelSx, disabled, onDisabledClick }) => {
    const [colorMode] = useColorMode();
    const isDarkMode = colorMode === 'dark';

    const circles = Array.from({ length: total }, (_, i) => i + 1);

    return (
        <Box sx={{ mb: 1, opacity: disabled ? 0.6 : 1, pointerEvents: 'auto', mt: 2 }} onClick={() => disabled && onDisabledClick && onDisabledClick()}>
            <Flex sx={{ alignItems: 'center', gap: 2 }}>
                <Text variant="SelectLabel" sx={{ minWidth: '85px', fontWeight: 600, lineHeight: 1.2, whiteSpace: 'nowrap', ...labelSx }}>
                    {label}
                </Text>
                <Flex sx={{ gap: '6px', alignItems: 'center' }}>
                    {circles.map((num: number) => {
                        const isFilled = num <= value;
                        return (
                            <Box
                                key={num}
                                onClick={() => {
                                    if (disabled) return;
                                    if (onCircleClick) {
                                        onCircleClick(num);
                                    } else {
                                        if (num === value) {
                                            onChange(num - 1);
                                        } else {
                                            onChange(num);
                                        }
                                    }
                                }}
                                sx={{
                                    width: '18px',
                                    height: '18px',
                                    borderRadius: '50%',
                                    cursor: (disabled || isFilled) ? 'not-allowed' : 'pointer',
                                    border: '1.5px solid',
                                    borderColor: isFilled ? '#4caf50' : (isDarkMode ? 'secondary' : '#e0e0e0'),
                                    backgroundColor: isFilled ? '#4caf50' : 'transparent',
                                    transition: 'all 0.15s ease-in-out',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    '&:hover': {
                                        transform: disabled ? 'none' : 'scale(1.1)',
                                        borderColor: disabled ? 'initial' : 'primary',
                                    },
                                }}
                            >
                                {isFilled && (
                                    <Box sx={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: 'white', opacity: 0.6 }} />
                                )}
                            </Box>
                        );
                    })}
                    <LuRotateCcw
                        size={16}
                        onClick={() => !disabled && value > 0 && onChange(0)}
                        style={{
                            cursor: (disabled || value === 0) ? 'not-allowed' : 'pointer',
                            marginLeft: '4px',
                            color: isDarkMode ? '#90cdf4' : '#666',
                            // opacity: (disabled || value === 0) ? 0.3 : 1,
                            transition: 'opacity 0.2s ease',
                        }}
                        title={value > 0 ? "Reset" : ""}
                    />
                </Flex>
            </Flex>
        </Box>
    );
};

export default CircleCounter;
